import DeviceUtils from '../utils/device.utils';
import { ConsoleEvent } from './console.event';
import DefaultConfig from '../constants/default.config';
import CaasStorageKeys from '../constants/caas.storage.keys';

const caas = JSON.parse(localStorage.getItem(CaasStorageKeys.CONFIG)) || {};
const client = JSON.parse(localStorage.getItem(CaasStorageKeys.CLIENT)) || {};
const device = JSON.parse(localStorage.getItem(CaasStorageKeys.DEVICE)) || {};
const storage = JSON.parse(localStorage.getItem(CaasStorageKeys.STORAGE)) || {};
const notifications =
  JSON.parse(localStorage.getItem(CaasStorageKeys.NOTIFICATIONS)) || [];

const __CAAS__ = {
  events: {
    requestPermission: 'request_permission',
    openDeeplink: 'open_deeplink',
    closeWebview: 'close_webview',
    callMicroblink: 'call_microblink',
    logConsole: 'log_console',
    openUrl: 'open_url',
    pressBack: 'press_back',
    interceptUrl: 'intercept_url',
    saveStorage: 'save_storage',
    refreshPage: 'refresh_page',
    refreshToken: 'refresh_token',
    trackEvent: 'track_event',
    getItems: 'get_items',
    authenticatePasscode: 'authenticate_passcode',
  },

  // This is populated in the ConfigContext
  config: {
    [CaasStorageKeys.CONFIG]: caas || {},
    [CaasStorageKeys.CLIENT]: client || {},
    [CaasStorageKeys.DEVICE]: device || {},
    [CaasStorageKeys.STORAGE]: {
      ...DefaultConfig,
      ...(storage || {}),
    },
    [CaasStorageKeys.NOTIFICATIONS]: notifications || [],
  },

  // to communicate from webview to native app
  triggerNative: (type, eventId, eventData = null) => {
    const body = { type, event_id: eventId, event_data: eventData };

    if (
      type !== __CAAS__.events.logConsole &&
      __CAAS__.config[CaasStorageKeys.CONFIG].debug
    ) {
      ConsoleEvent.log(JSON.stringify(body));
    }

    if (DeviceUtils.isAndroid()) {
      const stringifyBody = JSON.stringify(body);
      window.Android.nativeActionHandler(stringifyBody);
    } else if (DeviceUtils.isIos()) {
      window.webkit.messageHandlers.iosListener.postMessage(body);
    } else {
      console.error('System is not supported');
    }
  },

  // to communicate from native app to webiew
  notify: (type, eventId, eventData = {}) => {
    const event = new CustomEvent(type, {
      detail: { eventId, eventData },
    });
    document.dispatchEvent(event);

    if (
      type !== __CAAS__.events.logConsole &&
      __CAAS__.config[CaasStorageKeys.CONFIG].debug
    ) {
      ConsoleEvent.log(JSON.stringify({ type, eventId, eventData }));
    }
  },
};

export default __CAAS__;
